import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="py-12 bg-[#0F0505] border-t border-[#D4AF37]/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Heart className="w-5 h-5 text-[#D4AF37]" fill="#D4AF37" />
          <span className="font-['Playfair_Display'] text-lg text-[#F5F5F0]">Year One</span>
        </div>
        <p className="text-[#A18E90] text-sm mb-4">
          A digital love letter celebrating our first year of marriage
        </p>
        <p className="text-[#D4AF37] text-xs tracking-widest uppercase">
          One Year Down, Forever to Go
        </p>
        <div className="mt-8 pt-8 border-t border-[#D4AF37]/10">
          <p className="text-[#A18E90]/60 text-xs">
            Made with love, February 2026
          </p>
        </div>
      </div>
    </footer>
  );
};
